import { registerPedestal, registerComponents, registerItemComps } from './base/pedestal'

export default {
  registerPedestal,
  registerComponents,
  registerItemComps
}
